import store from '../../store';

const meta = {
  requiresLogin: true,
  requiresUserType: store.state.User.accountTypes.superAdmin,
};

export default [
  {
    path: 'programs',
    name: 'ProgramsView',
    component() {
      return import(/* webpackChunkName: "sadminviews" */ '../../views/Programs/ProgramsView.vue');
    },
    meta,
  },
  {
    path: 'programs/:id',
    name: 'ProgramView',
    component() {
      return import(/* webpackChunkName: "sadminviews" */ '../../views/Programs/ProgramView.vue');
    },
    props: true,
    meta,
  },
];
